import { render, staticRenderFns } from "./TitleListSortingSwitchPopover.vue?vue&type=template&id=74ec7b30"
import script from "./TitleListSortingSwitchPopover.vue?vue&type=script&lang=ts&setup=true"
export * from "./TitleListSortingSwitchPopover.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TitleListSortingSwitchPopover.vue?vue&type=style&index=0&id=74ec7b30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports